export default function formatDate( dateObj ) {
  var d = new Date( dateObj )
  var date = {
    y: d.getFullYear(),
    m: d.getMonth() + 1,
    d: d.getDate()
  }
  return `${date.y}-${date.m < 10 ? '0'+date.m : date.m}-${date.d < 10 ? '0'+date.d : date.d}`;
}